import './csf-global-content-types.scss';

(function ($, Drupal, once) {
  Drupal.behaviors.replaceSearchBarBehavior = {
    attach: function (context, settings) {

      once('replaceSearchBehavior', '#edit-s', context).forEach(function (element) {
        if (document.getElementById('ckeditor-search') && document.getElementById('edit-s')) {
          document.getElementById('ckeditor-search').value = document.getElementById('edit-s').value;
          document.getElementById('edit-s').remove();
        }
      });
      once('replaceResetBehavior', '#edit-reset', context).forEach(function (element) {
        document.getElementById('edit-reset').addEventListener("click", function (event) {
          event.preventDefault();
          window.location.href = window.location.origin + window.location.pathname;
        });
      });
    }
  };
})(jQuery, Drupal, once);

